import types from '../../types';

const pending = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_FIAT_PENDING_START:
      return { ...state, loading: true };

    case types.GET_FIAT_PENDING_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_FIAT_PENDING_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default pending;
